import { Component, Input, OnInit, Injector, EventEmitter, Output } from '@angular/core';

import { inject } from '@angular/core';

import { LibModulesWolcModule } from '../../../components/lib-modules-wolc.module';
import { BooktechAppService } from "../../../services/booktech-app.service";


@Component({
    selector: 'bt-row',
    imports: [LibModulesWolcModule],
    templateUrl: './bt-row.component.html',
    styleUrl: './bt-row.component.scss'
})
export class BtRowComponent {

  @Input() grid: any = { };
  @Input() grids: any[] = [];
  @Input() opts: any = { };


  @Input() cols: number = 0;
  @Input() g: any[] = [];

  constructor() {

  }

  ngOnInit(): void {
    if (this.grids?.length) this.g = [...this.grids];
    if (this.g == undefined) this.g = [ ];

    if (this.g.length < this.cols) {
      for (let i = this.g.length; i < this.cols; i++) {
        this.g.push(this.grid || { })
      }
    }
    // MiscUtil.extend(this.g, this.grid);

  }

}


